// Single source of truth for the responsive breakpoint ladder.
// Phone: ≤ PHONE_MAX  → 1-column cards
// Tablet: ≤ MOBILE_MAX → 2-column cards / full-screen popups
// Desktop: > MOBILE_MAX → data table / desktop popup panel
export const PHONE_MAX = 640;
export const MOBILE_MAX = 1024;
